/**
 * 10 быстрых нажатий по логотипу открывают админку.
 */

import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DEV_ROUTE, DEV_UNLOCK_CLICKS, DEV_UNLOCK_WINDOW_MS } from "../config/dev";

function useLogoDevUnlock() {
    const navigate = useNavigate();
    const clicksRef = useRef([]);

    return (event) => {
        const now = Date.now();
        clicksRef.current = clicksRef.current.filter((time) => now - time < DEV_UNLOCK_WINDOW_MS);
        clicksRef.current.push(now);

        if (clicksRef.current.length < DEV_UNLOCK_CLICKS) {
            return false;
        }

        clicksRef.current = [];
        event.preventDefault();
        navigate(DEV_ROUTE);
        return true;
    };
}

export default useLogoDevUnlock;
// hooks/useLogoDevUnlock.js
